define('SuiteDynamics.HeelAssistItemSwap.CartHooks', [
	'SuiteDynamics.HeelAssistItemSwap.CartHooks.ItemSwap.View',
	'LiveOrder.Model',
	'underscore'
], function (ItemSwapView, LiveOrderModel, _) {
	'use strict';

	var BOUND  = false;
	var OPENED = false;

	function hasHeelAssist(lines) {
		return _.some(lines || [], function (line) {
			var item = line && line.item;
			var v = item && ((item.extras && item.extras.custitem97) || item.custitem97);
			return v === true || v === 'T';
		});
	}

	return {
		mountToApp: function (container) {
			if (BOUND) return;
			BOUND = true;

			var layout = container.getComponent('Layout');
			var cart = container.getComponent('Cart');

			layout.on('afterShowContent', function (viewName) {
				if (viewName !== 'Cart.Detailed.View') {
					OPENED = false;
					return;
				}
				if (OPENED) return;

				var force = false;
				try { force = sessionStorage.getItem('heelassist:forceModal') === '1'; } catch (e) {}
				if (force) { try { sessionStorage.removeItem('heelassist:forceModal'); } catch (e2) {} }

				_.defer(function () {
					LiveOrderModel.getInstance().fetch().always(function () {
						cart.getLines().then(function (lines) {
							if (!force && !hasHeelAssist(lines)) return;

							OPENED = true;

							var modalView = new ItemSwapView({ container: container });
							layout.showContent(modalView, {
								showInModal: true,
								options: { modalOptions: { backdrop: 'static', keyboard: false } }
							});
						});
					});
				});
			});
		}
	};
});
